(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-cars-swiper"] && !Shopify.designMode) return;
  try {
    
(function () {
  function buildBullets(pagEl, originalCount, swiper) {
    if (!pagEl || !originalCount || !swiper) return;

    pagEl.innerHTML = '';

    for (var i = 0; i < originalCount; i++) {
      var b = document.createElement('span');
      b.className = 'swiper-pagination-bullet';
      b.setAttribute('data-bullet-index', String(i));

      b.addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-bullet-index'), 10);
        if (isNaN(idx)) return;
        swiper.slideToLoop(idx);
      });

      pagEl.appendChild(b);
    }
  }

  function syncBullets(pagEl, activeIndex) {
    if (!pagEl) return;

    var bullets = pagEl.querySelectorAll('.swiper-pagination-bullet');
    if (!bullets || bullets.length === 0) return;

    for (var i = 0; i < bullets.length; i++) {
      bullets[i].classList.remove('swiper-pagination-bullet-active');
    }
    if (bullets[activeIndex]) {
      bullets[activeIndex].classList.add('swiper-pagination-bullet-active');
    }
  }

  function getRealIndexByDataAttr(swiper) {
    if (!swiper || !swiper.slides || swiper.activeIndex == null) return 0;

    var activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return 0;

    var v = activeSlide.getAttribute('data-slide-index');
    var n = parseInt(v, 10);

    return isNaN(n) ? 0 : n;
  }

  function initSwiperForAll() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.cat-card-swiper__core').forEach(function (el) {
      var wrapper = el.closest('.cat-card-swiper');
      if (!wrapper) return;

      if (el.swiper) {
        el.swiper.destroy(true, true);
      }

      var slideCount = el.querySelectorAll('.swiper-slide').length;
      var originalCount = parseInt(wrapper.getAttribute('data-original-count'), 10) || 0;

      // ✅ 無限ループ必須：2枚以上ならloop（1枚はloop不可）
      var useLoop = slideCount >= 2;

      var pagEl = wrapper.querySelector('.cat-card-swiper__pagination');
      if (pagEl) {
        pagEl.innerHTML = '';
      }

      var swiper = new Swiper(el, {
        loop: useLoop,
        speed: 400,

        spaceBetween: 20,

        autoplay: useLoop
          ? {
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }
          : false,

        centeredSlides: true,
        slidesPerView: 1.5,

        breakpoints: {
          769: {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 5
          }
        },

        // ✅ Swiper標準のpagination生成は使わず、自前でbulletを生成する
        pagination: {
          el: pagEl,
          clickable: false
        },

        navigation: {
          nextEl: wrapper.querySelector('.swiper-button-next'),
          prevEl: wrapper.querySelector('.swiper-button-prev')
        },

        watchSlidesProgress: true,
        observeParents: true,
        observer: true,

        on: {
          init: function () {
            var self = this;

            // ✅ loop安定化
            if (useLoop) {
              self.params.loopedSlides = slideCount;
              self.params.loopAdditionalSlides = 2;
            }

            // ✅ bulletを元枚数だけ生成
            buildBullets(pagEl, originalCount, self);

            // ✅ 初期active同期
            var real = getRealIndexByDataAttr(self);
            syncBullets(pagEl, real);

            setTimeout(function () {
              self.update();
            }, 0);
          },

          slideChange: function () {
            var self = this;
            var real = getRealIndexByDataAttr(self);
            syncBullets(pagEl, real);
          }
        }
      });
    });
  }

  function ensureSwiperAssetsAndInit() {
    if (window.Swiper) {
      initSwiperForAll();
      return;
    }

    var cssHref = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
    if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssHref;
      document.head.appendChild(link);
    }

    var jsSrc = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
    if (!document.querySelector('script[src*="swiper-bundle.min.js"]')) {
      var s = document.createElement('script');
      s.src = jsSrc;
      s.defer = true;
      s.onload = initSwiperForAll;
      document.head.appendChild(s);
    } else {
      if (typeof Swiper !== 'undefined') initSwiperForAll();
      else window.addEventListener('load', initSwiperForAll);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureSwiperAssetsAndInit);
  } else {
    ensureSwiperAssetsAndInit();
  }

  document.addEventListener('shopify:section:load', function () {
    ensureSwiperAssetsAndInit();
  });
  document.addEventListener('shopify:section:select', function () {
    ensureSwiperAssetsAndInit();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"]) return;
  try {
    
  (() => {
    const select = document.getElementById('ContactForm--details');
    if (!select) return;

    const orderWrap = document.getElementById('ContactForm-orderid-wrapper');
    const productWrap = document.getElementById('ContactForm-product_name-wrapper');
    const orderInput = orderWrap ? orderWrap.querySelector('input') : null;
    const productInput = productWrap ? productWrap.querySelector('input') : null;

    const setVisible = (wrap, input, visible) => {
      if (!wrap) return;
      if (visible) {
        wrap.classList.remove('is-hidden');
        wrap.removeAttribute('hidden');
      } else {
        wrap.classList.add('is-hidden');
        wrap.setAttribute('hidden', 'hidden');
      }
      if (input) input.disabled = !visible;
    };

    const toggle = () => {
      const option = select.options[select.selectedIndex];
      const needsExtra = option && option.dataset.type === '1';
      setVisible(orderWrap, orderInput, needsExtra);
      setVisible(productWrap, productInput, needsExtra);
    };

    select.addEventListener('change', toggle);
    toggle();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d.close());
    }

    closeSearchModal() {
      // Dawn5カスタムでは details-modal が無い場合があるため null 安全化
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
